import { DateTime } from 'luxon';

export function daysBetweenDates(date1, date2) {
    const { values } = DateTime.fromJSDate(date1).diff(DateTime.fromJSDate(date2));
    return values.milliseconds / 60 / 60 / 1000 / 24;
}
